import { useEffect, useState } from "react";
import { api } from "../lib/api";

/**
 * Fetches and caches the business profile so the sidebar, PDFs' rendered
 * previews, and other internal surfaces reference the shop by its own name
 * (e.g. "Vinyl Wrapping Australia") instead of the app codename.
 */
const CACHE = { data: null, promise: null };

export function useBusinessProfile() {
  const [profile, setProfile] = useState(CACHE.data);

  useEffect(() => {
    if (CACHE.data) return;
    if (!CACHE.promise) {
      CACHE.promise = api.get("/business-profile")
        .then(({ data }) => { CACHE.data = data; return data; })
        .catch(() => { CACHE.data = { name: "WrapConsole" }; return CACHE.data; });
    }
    CACHE.promise.then(setProfile);
  }, []);

  const refresh = async () => {
    CACHE.promise = api.get("/business-profile").then(({ data }) => { CACHE.data = data; return data; });
    const d = await CACHE.promise;
    setProfile(d);
    return d;
  };

  return { profile: profile || { name: "WrapConsole" }, refresh };
}
